import $ from 'jquery';

var players = {};

/**
 * Lazily evaluate whether we're in a mobile viewport to account to screen
 * resizing and orientation changes.
 */
var isMobile = function() {
    return $(document).data('mediaQueryLabel').is('mobile') ||
        $(document).data('mediaQueryLabel').is('small');
};

/**
 * UA detect for IOS because it breaks all the things
 */
var isIOS = function() {
    return navigator.userAgent.match(/(iPad|iPhone|iPod)/g);
};

/**
 * Set up the player for desktop with autoplay and stop on close
 */
var playerForDesktop = function ($elem) {

    var name = $elem.data('modalName');
    var player = players[name];
    var modal = $elem.data('modal');

    if (!player) {

        player = players[name] = videojs(name + '-video'); // eslint-disable-line no-undef

        player.on('fullscreenchange', function(e) {
            if (isMobile() && !player.isFullScreen && !isIOS()) {
                modal.close();
            }
        });

        $(document)
            .on('modal:afterShow:' + name, function() {
                player.ready(function() {
                    player.play();
                });
            })
            .on('modal:beforeHide:' + name, function() {
                player.pause();
            })
        ;
    }
};

/**
 * Bind the view link to show the correct player
 */
var bindVideoLink = function() {

    $('[data-modal-type="video"]').each(function () {
        var $elem = $(this);

        $elem.on('click', function(event){
            if(isIOS() || isMobile()){
                event.stopPropagation();
            }
        });

        if (isIOS() || isMobile()) {
            return true;
        } else {
            playerForDesktop($elem);
        }
    });
};

export default {
    run: function() {
        $(function() {
            bindVideoLink();
        });
    }
};



// WEBPACK FOOTER //
// ./src/web/js/marketing/modules/videos.js